import { Box, Divider } from '@mui/material';
import { TabsV2 } from 'common/ui/TabsV2';
import { VerticalTabs } from 'common/ui/VerticalTabs';
import { TeamSection } from 'services/userOrganization/Components/TeamSection';
import { AccountVisibilitySection, AdministratorLayout } from './components';
import { administratorPageSx } from './styles';
import { EmptyState } from 'system/atoms';
import {
  useAccountVisibility,
  VisibilityFilter
} from './hooks/useAccountVisibility';
export const Administrator = () => {
  const {
    selectedOrg,
    visibilityFilter,
    visibilityTabs,
    filteredOrganizations,
    verticalTabItems,
    selectedIndex,
    isLoadingHiddenTab,
    handleVisibilityFilterChange,
    handleVisibilityChange,
    handleOrgTabChange
  } = useAccountVisibility();

  return (
    <AdministratorLayout>
      <TabsV2
        tabs={visibilityTabs}
        onChange={handleVisibilityFilterChange}
        value={visibilityFilter}
      />
      <Divider sx={administratorPageSx.divider} />
      {isLoadingHiddenTab ? (
        <EmptyState type="loading" title="Loading accounts" />
      ) : filteredOrganizations.length > 0 ? (
        <Box sx={administratorPageSx.contentLayout}>
          <Box sx={administratorPageSx.verticalTabsContainer}>
            <VerticalTabs
              key={visibilityFilter}
              items={verticalTabItems}
              defaultSelectedIndex={selectedIndex}
              showUnderline={false}
              onTabChange={handleOrgTabChange}
            />
          </Box>
          {selectedOrg ? (
            <Box sx={administratorPageSx.contentContainer}>
              <TeamSection
                title="Account teams"
                organizationId={selectedOrg.id}
              />
              <Divider sx={administratorPageSx.contentDivider} />
              <AccountVisibilitySection
                organization={selectedOrg}
                onViewHiddenAccounts={() =>
                  handleVisibilityFilterChange(VisibilityFilter.Hidden)
                }
                onVisibilityChange={handleVisibilityChange}
              />
            </Box>
          ) : (
            <Box sx={administratorPageSx.contentContainer}>
              <EmptyState type="loading" title="Loading account details" />
            </Box>
          )}
        </Box>
      ) : (
        <EmptyState
          type="no-records"
          title={
            visibilityFilter === VisibilityFilter.Hidden
              ? 'No hidden accounts'
              : 'No visible accounts'
          }
        />
      )}
    </AdministratorLayout>
  );
};
